<template>
  <div class="empty-list">
    <Lotus class="icon" />
    <div class="description t-lead-s" v-html="t('empty-search')" />
  </div>
</template>

<script lang="ts" setup>
import Lotus from '@/assets/icons/lotus.svg?component'

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.empty-list {
  @include center-content;
  flex-direction: column;
  padding-block: rem(50px) rem(80px);
  text-align: center;
  border: 1px solid $layout-divider;
  border-width: 1px 0;
}

.icon {
  @include size(rem(85px));
  margin-bottom: rem(8px);
  color: $layout-text-03;
}

.description {
  color: $layout-text-03;
}
</style>
